<template>
  <v-app-bar app clipped-left color="blue-grey lighten-2" dark height="46">
    <template v-if="onMobile">
      {{ path2 }}
      <div v-if="path=='dashboard'" class="mx-4">
        <v-select
          :items="getDashboardDateHorizon"
          label="Date horizon"
          dense
          hide-details
          single-line
        ></v-select>
      </div>

      <v-list-item v-if="hasSelectedProject" class="shadow mt-3 ml-n6" @click="returnToProjectList">
        <v-btn class="mt-n3 mr-3" color="orange darken-2" dark>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item-content class="mt-n3">
          <v-list-item-title v-text="addressLine"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <v-img
      src="../../../src/assets/loggable.webp"
      max-width="70px"
      class="mt-9"
      @click="gotoProjects"
    ></v-img>

    <v-spacer />

    <template v-if="onDesktop">
      <!-- <v-spacer></v-spacer> -->
      <TopNav></TopNav>
      <!-- <v-spacer></v-spacer> -->
    </template>

    <span class="mt-0">
      <v-avatar color="green" size="34">
        <span>
          <!-- <v-img width="30px" :src="require('@/assets/main/imgSettings.png')"></v-img> -->
          <span class="white--text">DH</span>
        </span>
      </v-avatar>
    </span>
    <!-- <span class="white--text text-subtitle-1 ml-3">{{ email }}</span> -->

    <v-menu bottom left offset-y>
      <template v-slot:activator="{ on }">
        <!-- <v-icon>mdi-dots-vertical</v-icon> -->
        <span class="white--text text-subtitle-1 ml-3" v-on="on" style="cursor: pointer">{{ email }}</span>
      </template>

      <v-list>
        <v-list-item v-for="(item, i) in items" :key="i" @click="logout">
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script lang="ts">
import { linkWithGoogle, unlinkWithGoogle, signOut } from "../../auth";
import TopNav from "./TopNav.vue";
import { storeprops } from "../../store/helpers.js";

export default {
  components: { TopNav },
  data: () => ({
    drawer: false,
    left: false,
    items: [{ title: "Logout" }],
  }),
  computed: {
    ...storeprops,
    onMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    onDesktop() {
      return !this.$vuetify.breakpoint.xsOnly;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    path() {
      return this.$route.name;
    },
    email() {
      if (!this.userInfo) return "--";
      return this.userInfo.email;
    },
    path2() {
      let name = this.$route.name;
      if (name == "projects" && this.selectedProject) return "";
      return name;
    },
    selectedProject() {
      return this.$store.state.selectedProject;
    },
    client() {
      if (this.selectedProject) return this.selectedProject.client;
      else return {};
    },
    addressLine() {
      if (this.client)
        return `${this.client.addressLine1}, ${this.client.city}`;
      else return "--";
    },
  },
  methods: {
    returnToProjectList() {
      this.$store.dispatch("setSelectedProject", null);
    },
    gotoProjects() {
      this.$router.push({ name: "projects" });
    },
    logout() {
      signOut();
    },
    linkWithGoogle() {
      linkWithGoogle((error) => alert(error));
    },
    unlinkWithGoogle() {
      unlinkWithGoogle((error) => alert(error));
    },
    createDummyData() {
      // *** literally for creating dummy data ***
      //const create = require("../../../create-data/create-test-data");
      //create.run();
    },
  },
  mounted() {
    // this sets the 'dark' mode to true/false - it works with the 'theme-ing'
    // this.$vuetify.theme.dark = true;
  },
};
</script>